export interface AppTranslations {
  productDescription: string;
  nav: {
    home: string;
    resources: string;
    help: string;
  },
  account: {
    account: string;
    logout: string;
  },
  notifications: {
    notifications: string;
    newDescriptor: string;
    noNewDescriptor: string;
  }
}

export const appTranslationKeys: AppTranslations = {
  productDescription: 'productDescription',
  nav: {
    home: 'nav.home',
    resources: 'nav.resources',
    help: 'nav.help',
  },
  account: {
    account: 'account.account',
    logout: 'account.logout',
  },
  notifications: {
    notifications: 'notifications.notifications',
    newDescriptor: 'notifications.newDescriptor',
    noNewDescriptor: 'notifications.noNewDescriptor',
  },
};

export const appTranslationsEN: AppTranslations = {
  productDescription: 'Assessment Portal',
  nav: {
    home: 'Home',
    resources: 'Resources',
    help: 'Help',
  },
  account: {
    account: 'Account',
    logout: 'Logout',
  },
  notifications: {
    notifications: 'Notifications',
    newDescriptor: 'new',
    noNewDescriptor: 'No new notifications',
  },
};

export const appTranslationsES: AppTranslations = {
  productDescription: 'Portal de Evaluación',
  nav: {
    home: 'Inicio',
    resources: 'Recursos',
    help: 'Ayuda',
  },
  account: {
    account: 'Cuenta',
    logout: 'Cerrar sesión',
  },
  notifications: {
    notifications: 'Notificaciones',
    newDescriptor: 'nuevo',
    noNewDescriptor: 'No hay notificaciones nuevas',
  },
};
